export const notificationConstants = {
  // hms client token
  GET_CALENDAR_NOTIFICATIONS_ACTION_REQUEST:
    "GET_CALENDAR_NOTIFICATIONS_ACTION_REQUEST",
  GET_CALENDAR_NOTIFICATIONS_ACTION_SUCCESS:
    "GET_CALENDAR_NOTIFICATIONS_ACTION_SUCCESS",
  GET_CALENDAR_NOTIFICATIONS_ACTION_FAILURE:
    "GET_CALENDAR_NOTIFICATIONS_ACTION_FAILURE",

  //mark notifications read\
  MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_REQUEST:
    "MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_REQUEST",
  MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_SUCCESS:
    "MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_SUCCESS",
  MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_FAILURE:
    "MARK_CALENDAR_NOTIFICATIONS_READ_ACTION_FAILURE",

  // hms client token
  GET_INVITED_JOBS_NOTIFICATIONS_ACTION_REQUEST:
    "GET_INVITED_JOBS_NOTIFICATIONS_ACTION_REQUEST",
  GET_INVITED_JOBS_NOTIFICATIONS_ACTION_SUCCESS:
    "GET_INVITED_JOBS_NOTIFICATIONS_ACTION_SUCCESS",
  GET_INVITED_JOBS_NOTIFICATIONS_ACTION_FAILURE:
    "GET_INVITED_JOBS_NOTIFICATIONS_ACTION_FAILURE",

  // hms client token
  MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_REQUEST:
    "MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_REQUEST",
  MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_SUCCESS:
    "MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_SUCCESS",
  MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_FAILURE:
    "MARK_INVITED_JOBS_NOTIFICATIONS_READ_ACTION_FAILURE",

  // hms client token
  GET_JOB_CHANGES_NOTIFICATIONS_ACTION_REQUEST:
    "GET_JOB_CHANGES_NOTIFICATIONS_ACTION_REQUEST",
  GET_JOB_CHANGES_NOTIFICATIONS_ACTION_SUCCESS:
    "GET_JOB_CHANGES_NOTIFICATIONS_ACTION_SUCCESS",
  GET_JOB_CHANGES_NOTIFICATIONS_ACTION_FAILURE:
    "GET_JOB_CHANGES_NOTIFICATIONS_ACTION_FAILURE",

  // hms client token
  MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_REQUEST:
    "MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_REQUEST",
  MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_SUCCESS:
    "MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_SUCCESS",
  MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_FAILURE:
    "MARK_JOB_CHANGES_NOTIFICATIONS_READ_ACTION_FAILURE",
};
